import React, { useState, useEffect } from 'react';
import InfoButtonWithPopover from "./InfoButtonWithPopover";

const TablaComponente = ({ data }) => {

    console.log("DATAx EN TablaComponente (3) --->", data)
    
    return (
        <div className="overflow-x-auto shadow-md sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                <thead className="bg-gray-50 dark:bg-gray-800">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Nombre de Obra</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Expediente</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Objeto</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Fecha Salida Convenio</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Fecha Firma Convenio</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Fecha Salida Reso</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Fecha Firma Reso</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Observaciones Externas</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">Etapa Exp.</th>
                    </tr>
                </thead>
                {/*<tbody className="bg-white divide-y divide-gray-200">
                    {renderTableRows()}
                </tbody>*/}
                <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
                    {data.map((item, index) => { 
                        
                        //console.log("TECNICO", Object.prototype.toString.call(item.fecha_salida_convenio));

                        //if (item.fecha_salida_conferencia !== undefined || item.fecha_salida_conferencia !== null)
                        //if (item.fecha_salida_convenio != null ){
                        if (item.fecha_salida_convenio){
                            const value_etapa_exp = 
                            (item.fecha_firma_reso !== undefined && item.fecha_firma_reso !== null) ? 100 : //null or undefined
                            (item.fecha_salida_reso !== undefined && item.fecha_salida_reso !== null) ? 75 :
                            (item.fecha_firma_convenio !== undefined && item.fecha_firma_convenio !== null) ? 50 : 25;
                            
                            return(
                            <tr key={item.id_unico || `${item.id}-${item.nombre_obra}`} 
                            className="hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer transition-colors duration-150">
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900 dark:text-gray-200">{item.nombre_obra || 'N/A'}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">{item.exp || 'N/A'}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">{item.objeto || 'N/A'}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">{item.fecha_salida_convenio ? new Date(item.fecha_salida_convenio).toLocaleDateString('es-AR') : 'N/A'}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">{item.fecha_firma_convenio ? new Date(item.fecha_firma_convenio).toLocaleDateString('es-AR') : 'N/A'}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">{item.fecha_salida_reso ? new Date(item.fecha_salida_reso).toLocaleDateString('es-AR') : 'N/A'}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">{item.fecha_firma_reso ? new Date(item.fecha_firma_reso).toLocaleDateString('es-AR') : 'N/A'}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400">{item.observaciones_externas || 'N/A'}</td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                                        <div 
                                            className={`h-2.5 rounded-full ${
                                                value_etapa_exp === 100 ? 'bg-green-600' : 
                                                value_etapa_exp < 100 ? 'bg-blue-600' : 
                                                'bg-red-600'
                                            }`} 
                                            style={{ width: `${value_etapa_exp}%` }}
                                        ></div>
                                    </div>
                                    <span className="text-xs text-gray-500 dark:text-gray-400">
                                        {value_etapa_exp}%
                                    </span>
                                </td>
                            </tr>
                            )
                        }
                    })}    
                </tbody>
            </table>
        </div>
    );
};

export default TablaComponente;